<template>
    <div class="page-container">
        <div class="page-slider">
            <TreeModel @deptRow="getDeptRow" :updateModel="updateTree"></TreeModel>
        </div>
        <div class="page-content-right">
            <div class="page-info-wrapper2">
                <div class="page-info-content">
                    <div class="page-info-content-company2">
                        <img src="@/assets/img/gongsi.png" alt="" class="company-logo">
                        <div class="page-info-content-company-name">
                            企业名称：{{ branchFullName }}
                        </div>
                        <div v-if="userInfo.role != 0" class="page-info-set" @click="handleEditBranch">
                            <div class="page-info-set-img-wrapper">
                                <img src="@/assets/img/shape1.png" alt="" class="rect-image">
                            </div>
                            <div class="page-info-set-wrapper">
                                <img src="@/assets/img/reset.png" alt="" class="info-set-img">
                            </div>
                            <div class="page-info-reset-label">设置</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-container">
                <div class="page-content-header page-branch">
                    <div class="page-header-block"></div>
                    <div class="page-content-header-item-active">子公司/部门</div>
                    <div v-if="userInfo.role != 0 && branchShow && activeRow.level != 2" class="page-header-operate">
                        <img src="@/assets/img/branch.png" alt="" class="page-header-operate-img">
                        <span class="page-header-operate-label" @click="handleAddBranch">添加子公司/部门</span>
                    </div>
                </div>
                <div v-if="branchData.length > 0" class="page-branch-content-wrapper">
                    <div v-for="(item, key) in branchData" :key="'branch-' + key" class="page-branch-item"
                        @click="handleBranchItem(item)">
                        <div>{{ item.deptName }}({{ item.memberCount }})</div>
                        <div><i class="el-icon-arrow-right page-branch-item-icon"></i></div>
                    </div>
                </div>
                <div v-else class="page-branch-content-wrapper">
                    <div class="page-branch-no-data">
                        <div>当前部门不包含下级部门~</div>
                    </div>
                </div>
            </div>

            <div class="page-content-container">
                <div class="page-content-header">
                    <div class="page-header-block"></div>
                    <div class="page-content-header-item-active">成员管理</div>
                </div>
                <div v-if="userInfo.role != 0 && viewMember" class="page-title-container">
                    <div class="page-title-wrapper">
                        <div class="page-title-left">
                            <div class="page-title-btn page-title-btn-gap" @click="handleAddMember">
                                <img src="@/assets/img/add.png" alt="" class="page-title-btn-icon">
                                添加成员
                            </div>
                            <div class="page-title-btn-gap">
                                <el-upload ref="upload" :action="uploadURL" :limit="1" :on-change="uploadExcelData"
                                    :on-success="handleAvatarSuccess" :show-file-list="false" :auto-upload="false"
                                    :file-list="uploadList">
                                    <div class="page-title-btn">
                                        <img src="@/assets/img/download.png" alt="" class="page-title-btn-icon">
                                        批量导入
                                    </div>
                                </el-upload>
                            </div>
                            <div class="page-title-btn" @click="handleEmptyMember">
                                <img src="@/assets/img/delete.png" alt="" class="page-title-btn-icon">
                                批量删除
                            </div>
                        </div>
                        <div class="page-title-right">
                            <div class="page-title-btn" @click="downloadTemplate">
                                <img src="@/assets/img/download.png" alt="" class="page-title-btn-icon">
                                下载模板
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-wrap">
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <el-input v-model="searchForm.keyword" placeholder="请输入姓名/手机号"></el-input>
                        </el-col>
                        <el-col :span="10">
                            <el-input v-model="searchForm.position" placeholder="请输入职位"></el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" @click.native="searchMembers">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
                <div class="page-content-wrapper">
                    <div class="table-wrapper">
                        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" border
                            @selection-change="handleTableSelect">
                            <el-table-column width="100" align="center" type="selection">
                            </el-table-column>
                            <el-table-column label="姓名" align="center">
                                <template slot-scope="scope">
                                    <span class="table-name">{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="mobile" label="手机号" align="center">
                                <template slot-scope="scope">
                                    <span class="table-row">{{ scope.row.mobile }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="position" label="职位" align="center">
                                <template slot-scope="scope">
                                    <span class="table-row">{{ scope.row.position }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="role" label="角色" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.role == 2" class="table-row">超级管理员</span>
                                    <span v-else-if="scope.row.role == 1" class="table-row">管理员</span>
                                    <span v-else class="table-row">普通用户</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <div v-if="userInfo.role == 2 || (userInfo.role != 0 && branchMenu)">
                                        <img src="@/assets/img/delete.png" alt="" class="table-icon"
                                            @click="handleDeleteMember(scope.row)">
                                        <img src="@/assets/img/edit.png" alt="" class="table-icon table-icon-gap"
                                            @click="handleEditMember(scope.row)">
                                    </div>
                                    <div v-else class="table-operate-no">
                                        <div class="table-operate-no-item">-</div>
                                        <div class="table-operate-no-item">-</div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-if="tableData.length == 0" class="no-data-wrapper">
                    <img src="@/assets/img/nodata.png" alt="" class="no-data-img">
                    <div class="no-data-label">您还未开通课程学习，可联系课程顾问获取帮助！</div>
                </div>
                <div v-if="tableData.length > 0" class="pagination-wrapper">
                    <el-pagination small background layout="prev, pager, next" :current-page="currentPage"
                        :total="totalRows" @current-change="changePage">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--添加部门-->
        <el-dialog title="" :show-close="false" width="600px" :visible.sync="addBranchDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>添加子公司/部门</div>
            </div>
            <div class="dialog-content">
                <el-form ref="addBranchForm" :model="addBranchForm" label-width="160px">
                    <el-form-item label="公司/部门名称：" prop="name">
                        <el-input v-model="addBranchForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="子公司/部门主管：" prop="director">
                        <el-select v-model="addBranchForm.director" placeholder="">
                            <el-option v-for="(item, key) in branchMemberList" :key="'addBranch-' + key" :label="item.name"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="dialog-btn-wrapper">
                        <el-button type="primary" @click="addBranch">保存</el-button>
                        <el-button @click="cancelAddBranch">取消</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--编辑部门-->
        <el-dialog title="" :show-close="false" width="600px" :visible.sync="editBranchDialog"
            class="team-manage-container">
            <div class="dialog-header">
                <div>公司/部门设置</div>
            </div>
            <div class="dialog-content">
                <el-form ref="editBranchForm" :model="editBranchForm" label-width="160px" enctype="multipart/form-data">
                    <el-form-item v-if="userInfo.role == 2 && activeRow.level == 0" label="logo：" prop="logo">
                        <div class="editBranchForm-logo-wrapper">
                            <el-upload ref="upload-logo" :action="uploadURL" :limit="1" :http-request="uploadLogo"
                                :show-file-list="false" :auto-upload="true">
                                <div class="editBranchForm-logo-btn">
                                    选择文件
                                </div>
                            </el-upload>
                            <div class="editBranchForm-logo-info">{{ fileName }}</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="公司/部门名称：" prop="name">
                        <el-input v-if="userInfo.role == 2 && activeRow.level == 0" v-model="editBranchForm.name"
                            disabled></el-input>
                        <el-input v-else v-model="editBranchForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="子公司/部门主管：" prop="director">
                        <el-select v-if="userInfo.role == 2 && activeRow.level == 0" v-model="editBranchForm.director"
                            placeholder="" disabled>
                            <el-option v-for="(item, key) in branchMemberList" :key="'editBranch-' + key" :label="item.name"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                        <el-select v-else v-model="editBranchForm.director" placeholder="">
                            <el-option v-for="(item, key) in branchMemberList" :key="'editBranch-' + key" :label="item.name"
                                :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="dialog-btn-wrapper">
                        <el-button type="primary" @click="editBranch">保存</el-button>
                        <!-- <el-button v-if="userInfo.role!=2 && activeRow.level!=0" @click="deleteBranch">删除</el-button> -->
                        <el-button v-if="userInfo.role != 0 && activeRow.level != 0" @click="deleteBranch">删除</el-button>
                        <el-button @click="cancelEditBranch">取消</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加成员-->
        <el-dialog title="" :show-close="false" width="524px" :visible.sync="addMemberDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>添加成员</div>
            </div>
            <div class="dialog-content">
                <el-form ref="addMemberForm" :rules="addMemberRules" :model="addMemberForm" label-width="97px">
                    <el-form-item label="姓名：" prop="name">
                        <el-input v-model="addMemberForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：" prop="phone">
                        <el-input v-model="addMemberForm.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="职位：">
                        <el-input v-model="addMemberForm.position"></el-input>
                    </el-form-item>
                    <div class="dialog-btn-wrapper">
                        <el-button type="primary" @click="addMember">保存</el-button>
                        <el-button type="primary" @click="keepAddMember">保存并继续</el-button>
                        <el-button @click="cancelAddMember">取消</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--编辑成员-->
        <el-dialog title="" :show-close="false" width="600px" :visible.sync="editMemberDialog"
            class="team-manage-container">
            <div class="dialog-header">
                <div>编辑成员</div>
            </div>
            <div class="dialog-content">
                <el-form ref="addMemberForm" :rules="addMemberRules" :model="editMemberForm" label-width="130px">
                    <el-form-item label="姓名：" prop="name">
                        <el-input v-model="editMemberForm.name" :clearable="true"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：" prop="phone">
                        <el-input v-model="editMemberForm.mobile" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="是否为管理员：">
                        <el-radio-group v-if="!editMemberInfo" v-model="editMemberForm.role">
                            <el-radio v-if="editMemberForm.role == 2" :label="2">是</el-radio>
                            <el-radio v-else :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                        <el-radio-group v-if="editMemberInfo" v-model="editMemberForm.role" disabled>
                            <el-radio v-if="editMemberForm.role == 2" :label="2">是</el-radio>
                            <el-radio v-else :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="职位：">
                        <el-input v-model="editMemberForm.position"></el-input>
                    </el-form-item>
                    <el-form-item label="查看学习记录：">
                        <div class="dialog-view-detail-btn" @click="viewStudyDerail(editMemberForm)">查看学习记录</div>
                    </el-form-item>
                    <div class="dialog-edit-detail-info">
                        备注：若想切换用户部门，请联系课程顾问协助更换！
                    </div>
                    <div class="dialog-btn-wrapper">
                        <el-button type="primary" @click="conserveEditMember">保存</el-button>
                        <el-button v-if="!editMemberInfo" type="primary" @click="editDeleteMember">删除成员</el-button>
                        <el-button v-if="!editMemberInfo" @click="handleRemoveMember">移除团队</el-button>
                        <el-button @click="cancelEditMember">取消</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--删除成员-->
        <el-dialog title="" :show-close="false" width="524px" :visible.sync="tipsDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    删除该成员表示将该成员从企业中彻底清除，无法找回，只能重新添加，是否确认此操作？
                </div>
                <div class="dialog-btn-wrapper">
                    <el-button type="primary" @click="deleteMember">确定</el-button>
                    <el-button @click="cancelDeleteTips">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <!--批量删除-->
        <el-dialog title="" :show-close="false" width="524px" :visible.sync="emptyDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    批量删除成员表示将所有成员从企业中彻底清除，无法找回，只能重新添加，是否确认此操作？
                </div>
                <div class="dialog-btn-wrapper">
                    <el-button type="primary" @click="emptyMember">批量删除</el-button>
                    <el-button @click="removeAllMember">批量移除</el-button>
                    <el-button @click="cancelEmpty">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <!--移出团队-->
        <el-dialog title="" :show-close="false" width="524px" :visible.sync="removeDialog" class="team-manage-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    移出团队表示将该成员移出当前所在团队，学习记录等可保留，可在上级找回此人，是否确认此操作？
                </div>
                <div class="dialog-btn-wrapper">
                    <el-button type="primary" @click="removeMember">确定</el-button>
                    <el-button @click="cancelRemoveTips">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getDepartmentInformation,
    getDepartmentMember,
    addDepartmentMember,
    importMember,
    editDepartmentMember,
    deleteDepartmentMember,
    removeDepartmentMember,
    departmentBranchMemberList,
    addDepartmentBranch,
    editDepartmentBranch,
    editBranchInfo,
    deleteDepartmentBranch,
    editCompanyLogo,
    transformCpmpany,
    editDepartmentMemberInfo,
    downloadTemplete,
    emptyBatchMember
} from '@/api/index.js';
import Banner from '@/components/Banner.vue'
import TreeModel from '@/components/TreeModel.vue'
import XLSX from 'xlsx'
import config from '@/config';
import axios from 'axios'
import qs from 'qs'
export default {
    inject: ['reload'],
    name: '',
    components: {
        Banner,
        TreeModel
    },
    data() {
        return {
            listMode: "team-manage",
            editRole: false,
            userInfo: {},
            treeData: [],
            tableData: [],
            branchData: [],
            //是否可添加子公司
            branchShow: true,
            //是否可设置
            branchMenu: false,
            //是否可查看成员
            viewMember: false,
            updateTree: 0,
            fileList: [],
            branchFullName: '',
            //添加部门
            addBranchDialog: false,
            addBranchForm: {
                name: "",
                director: ""
            },
            branchMemberList: [],
            //编辑部门
            editBranchDialog: false,
            editBranchForm: {
                logo: '',
                name: "",
                director: ""
            },
            uploadURL: '',
            fileName: '未选择任何文件',
            branchInfo: {},
            activeDept: null,
            activeRow: {},
            //添加成员
            addMemberDialog: false,
            addMemberForm: {
                name: "",
                phone: "",
                role: "",
                position: "",
            },
            addMemberRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ]
            },
            //温馨提示
            tipsDialog: false,
            activeDeleteMember: {},
            //移出团队
            removeDialog: false,
            removeMemberForm: {},
            //编辑成员
            editMemberDialog: false,
            editMemberForm: {
                position: ''
            },
            editMemberInfo: false,
            //批量删除
            emptyDialog: false,
            tableEmptyArr: [],
            totalRows: 0,
            currentPage: 1,
            dept: '',
            token: '',
            uploadList: [],
            searchForm: { // 搜索
                keyword: '',
                position: '',
            }
        }
    },
    created() {
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
         this.token = window.localStorage.getItem('token');
        this.dept = window.localStorage.getItem('dept');
    },
    mounted() {
        const baseUrl = config.baseUrl;
        this.uploadURL = baseUrl + '/api/saas/updateCompanyLogo';
        this.userInfo = JSON.parse(window.localStorage.getItem('user'));
    },
    methods: {
        getDeptRow(row) {
            var target = JSON.parse(row);
            this.branchData = [];
            if (target.children && target.children != null) {
                this.branchData = target.children;
            }
            this.branchShow = target.enableAddChild;
            this.branchMenu = target.enableEdit;
            this.viewMember = target.enableViewMember;
            this.activeRow = target;
            this.activeDept = target.deptId;
            this.getDepInfo();
            this.getMembers();
        },
        handleBranchItem(row) {
            this.branchData = [];
            if (row.children && row.children != null) {
                this.branchData = row.children;
            }
            this.branchShow = row.enableAddChild;
            this.branchMenu = row.enableEdit;
            this.viewMember = row.enableViewMember;
            this.activeRow = row;
            this.activeDept = row.deptId;
            this.getDepInfo();
            this.getMembers();
        },
        getDepInfo() {
            var activeDept = this.activeDept;
            getDepartmentInformation(activeDept, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.branchFullName = data.deptName;
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        getCompanyInfo() {
            var activeDept = this.activeDept;
            transformCpmpany(activeDept, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        getMembers() {
            var _this = this;
            getDepartmentMember({
                "deptId": _this.activeDept,
                "keyword": _this.searchForm.keyword,
                "position": _this.searchForm.position,
                "pageNum": _this.currentPage,
                "pageSize": 10,
                "userDeptId": this.deptId,
                "userId": 0,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    this.totalRows = res.data.totalRecords;
                    this.tableData = data;
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        changePage(num) {
            this.currentPage = num;
            this.getMembers();
        },
        //新增部门
        handleAddBranch() {
            var _this = this;
            this.getBranchMemberList(function () {
                _this.addBranchForm = {
                    name: "",
                    director: ""
                };
                _this.addBranchDialog = true;
            });
        },
        getBranchMemberList(callback) {
            var _this = this;
            departmentBranchMemberList({
                "deptId": _this.activeDept,
                "keyword": "",
                "pageNum": 1,
                "pageSize": 100000,
                "userDeptId": 0,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.branchMemberList = res.data.list;
                    callback();
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        addBranch() {
            var addBranchForm = this.addBranchForm;
            if (addBranchForm.name == '') {
                this.$message.error('请输入公司/部门名称');
                return false;
            }
            var adminName = '';
            var memberList = this.branchMemberList;
            if (memberList.length > 0) {
                for (var i = 0; i < memberList.length; i++) {
                    var item = memberList[i];
                    if (item.userId == Number(addBranchForm.director) && item.userId != '') {
                        adminName = item.name;
                    }
                    if (i == memberList.length - 1) {
                        this.realAddBranch(adminName);
                    }
                }
            } else {
                this.realAddBranch(adminName);
            }
        },
        realAddBranch(adminName) {
            var addBranchForm = this.addBranchForm;
            var activeRow = this.activeRow;
            addDepartmentBranch({
                "currentUserId": 0,
                "deptName": addBranchForm.name,
                "parentDeptId": activeRow.deptId,
                "userId": addBranchForm.director,
                "deptAdminName": adminName
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.addBranchDialog = false;
                    this.$message({
                        message: '添加子公司/部门成功',
                        type: 'success'
                    });
                    var num = 10000 * Math.random();
                    this.updateTree = Number(num.toFixed(0));
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        cancelAddBranch() {
            this.addBranchDialog = false;
        },
        //编辑部门
        handleEditBranch() {
            var _this = this;
            this.getBranchMemberList(function () {
                _this.getEditBranchInfo();
            });
        },
        getEditBranchInfo() {
            var _this = this;
            editBranchInfo(_this.activeDept, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.branchInfo = data;
                    this.editBranchForm = {
                        name: data.deptName,
                        director: data.deptAdminUserId
                    }
                    this.editBranchDialog = true;
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        editBranch() {
            var editBranchForm = this.editBranchForm;
            var name = editBranchForm.name;
            var director = editBranchForm.director;
            if (name == '') {
                this.$message.error('请输入公司/部门名称');
                return false;
            }
            var adminName = '';
            var memberList = this.branchMemberList;
            if (memberList.length > 0) {
                for (var i = 0; i < memberList.length; i++) {
                    var item = memberList[i];
                    if (item.userId == Number(director) && item.userId != '') {
                        adminName = item.name;
                    }
                    if (i == memberList.length - 1) {
                        this.realEditBranch(adminName);
                    }
                }
            } else {
                this.realEditBranch(adminName);
            }
        },
        realEditBranch(adminName) {
            var _this = this;
            var editBranchForm = this.editBranchForm;
            editDepartmentBranch({
                "currentUserId": 0,
                "deptId": _this.activeDept,
                "deptName": editBranchForm.name,
                "userId": editBranchForm.director,
                "deptAdminName": adminName
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.editBranchDialog = false;
                    this.$message({
                        message: '设置公司/部门成功',
                        type: 'success'
                    });
                    var num = 10000 * Math.random();
                    this.updateTree = Number(num.toFixed(0));
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        deleteBranch() {
            var _this = this;
            deleteDepartmentBranch({
                "deptId": _this.activeDept,
                "type": 0,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.editBranchDialog = false;
                    this.$message({
                        message: '删除公司/部门成功',
                        type: 'success'
                    });
                    var num = 10000 * Math.random();
                    this.updateTree = Number(num.toFixed(0));
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        cancelEditBranch() {
            this.editBranchDialog = false;
        },
        //保存新增人员
        handleAddMember() {
            this.addMemberForm = {
                name: "",
                director: "",
                brief: ""
            };
            this.addMemberDialog = true;
        },
        addMember() {
            var _this = this;
            this.addMemberData(function () {
                _this.addMemberDialog = false;
                _this.getMembers();
                _this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                var num = 10000 * Math.random();
                _this.updateTree = Number(num.toFixed(0));
            });
        },
        addMemberData(callback) {
            var addMemberForm = this.addMemberForm;
            if (addMemberForm.name == '') {
                this.$message.error('请输入姓名');
                return false;
            }
            if (addMemberForm.phone == '') {
                this.$message.error('请输入手机号');
                return false;
            }
            if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(addMemberForm.phone)) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            var user = JSON.parse(window.localStorage.getItem('user'));
            var _this = this;
            addDepartmentMember({
                "deptId": _this.activeDept,
                "members": [
                    {
                        "mobile": addMemberForm.phone,
                        "name": addMemberForm.name,
                        "position": addMemberForm.position,
                    }
                ],
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    callback();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        //保存新增人员并继续
        keepAddMember() {
            var _this = this;
            this.addMemberData(function () {
                _this.addMemberForm = {
                    name: "",
                    phone: "",
                    role: ""
                }
                _this.getMembers();
                _this.$message({
                    message: '添加成员成功',
                    type: 'success'
                });
                var num = 10000 * Math.random();
                _this.updateTree = Number(num.toFixed(0));
            });
        },
        //取消添加人员
        cancelAddMember() {
            this.addMemberDialog = false;
        },
        //删除人员
        handleDeleteMember(row) {
            editDepartmentMemberInfo(row.deptId, row.userId, {

            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.editMemberInfo = res.data.myself;
                    if (!this.editMemberInfo) {
                        this.tipsDialog = true;
                        this.activeDeleteMember = row;
                    } else {
                        this.$message.error("当前登录用户无法删除");
                    }
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });

        },
        deleteMember() {
            var row = this.activeDeleteMember;
            var _this = this;
            this.dealDeleteMember(row.userDeptId, function () {
                _this.tipsDialog = false;
                _this.editMemberDialog = false;
                _this.getMembers();
                _this.$message({
                    message: '删除成员成功',
                    type: 'success'
                });
                var num = 10000 * Math.random();
                _this.updateTree = Number(num.toFixed(0));
            });
        },
        dealDeleteMember(id, callback) {
            var _this = this;
            deleteDepartmentMember(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    callback();
                } else {
                    this.$message.error(res.msg);
                    this.tipsDialog = false;
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        cancelDeleteTips() {
            this.tipsDialog = false;
        },
        editDeleteMember() {
            this.tipsDialog = true;
            this.activeDeleteMember = this.editMemberForm;
        },
        //移出团队
        handleRemoveMember() {
            this.removeMemberForm = this.editMemberForm;
            this.removeDialog = true;
        },
        removeMember() {
            var _this = this;
            this.dealRemoveMember(function () {
                _this.removeDialog = false;
                _this.editMemberDialog = false;
                _this.getMembers();
                _this.$message({
                    message: '移除团队成功',
                    type: 'success'
                });
                var num = 10000 * Math.random();
                _this.updateTree = Number(num.toFixed(0));
            });
        },
        dealRemoveMember(callback) {
            var row = this.removeMemberForm;
            removeDepartmentMember(row.userDeptId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    callback();
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        cancelRemoveTips() {
            this.removeDialog = false;
        },
        //批量移除
        removeAllMember() {
            var arr = this.tableEmptyArr;
            var _this = this;
            for (var i = 0; i < arr.length; i++) {
                var item = arr[i];
                this.removeMemberForm = item;
                if (i == arr.length - 1) {
                    this.dealRemoveMember(function () {
                        _this.emptyDialog = false;
                        _this.getMembers();
                        _this.$message({
                            message: '批量移除团队成功',
                            type: 'success'
                        });
                        var num = 10000 * Math.random();
                        _this.updateTree = Number(num.toFixed(0));
                    });
                } else {
                    this.dealRemoveMember(function () { });
                }
            }
        },
        //批量删除
        handleEmptyMember() {
            var arr = this.tableEmptyArr;
            if (arr.length == 0) {
                this.$message({
                    message: '请选择批量删除的成员',
                    type: 'warning'
                });
            } else {
                this.emptyDialog = true;
            }
        },
        emptyMember() {
            var arr = this.tableEmptyArr;
            var _this = this;
            var newArr = [];
            for (var i = 0; i < arr.length; i++) {
                var item = arr[i];
                newArr.push(item.userDeptId);
                if (i == arr.length - 1) {
                    emptyBatchMember([...new Set(newArr)], {
                        Authorization: this.token,
                        DeptId: this.dept
                    }).then(res => {
                        if (res.code == 200) {
                            _this.emptyDialog = false;
                            _this.getMembers();
                            _this.$message({
                                message: '批量删除成员成功',
                                type: 'success'
                            });
                            var num = 10000 * Math.random();
                            _this.updateTree = Number(num.toFixed(0));
                        }
                        return;
                    }).catch(err => {
                        ///console.log(err);
                    });
                }
            }
        },
        cancelEmpty() {
            this.emptyDialog = false;
        },
        handleTableSelect(row) {
            this.tableEmptyArr = row;
        },
        //编辑人员
        handleEditMember(row) {
            this.editMemberForm = row;
            editDepartmentMemberInfo(row.deptId, row.userId, {

            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.editMemberInfo = res.data.myself;
                    this.editMemberDialog = true;
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        conserveEditMember() {
            var row = this.editMemberForm;
            editDepartmentMember({
                "name": row.name,
                "role": row.role,
                "userDeptId": row.userDeptId,
                "position": row.position,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.getMembers();
                    this.$message({
                        message: '编辑成员成功',
                        type: 'success'
                    });
                    this.editMemberDialog = false;
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        cancelEditMember() {
            this.editMemberDialog = false;
        },
        //下载模板
        downloadTemplate() {
            /*downloadTemplete({},{
                Authorization:this.token,
                DeptId:this.dept,
                responseType: 'blob'
            }).then(res => {
                let blob=new Blob([res.data],{type: 'data:application/vnd.ms-excel;base64;charset=utf-8'});
                let downloadElement=document.createElement('a');
                let href=window.URL.createObjectURL(blob);
                downloadElement.href=href;
                downloadElement.download='templete.xlsx';
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
                return;
            }).catch(err => {
                ///console.log(err);
            });*/
            let sheet1data = [
                { 姓名: '', 手机号: '', 职位: '' }
            ];
            var sheet1 = XLSX.utils.json_to_sheet(sheet1data);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet1, '');
            const workbookBlob = this.workbook2blob(wb);
            this.openDownloadDialog(workbookBlob, 'templete.xlsx');
        },
        openDownloadDialog(blob, fileName) {
            if (typeof blob === 'object' && blob instanceof Blob) {
                blob = URL.createObjectURL(blob)
            }
            var aLink = document.createElement('a')
            aLink.href = blob
            aLink.download = fileName || ''
            var event
            if (window.MouseEvent) event = new MouseEvent('click')
            else {
                event = document.createEvent('MouseEvents')
                event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            }
            aLink.dispatchEvent(event)
        },
        workbook2blob(workbook) {
            var wopts = {
                bookType: 'xlsx',
                bookSST: false,
                type: 'binary'
            }
            var wbout = XLSX.write(workbook, wopts)
            function s2ab(s) {
                var buf = new ArrayBuffer(s.length)
                var view = new Uint8Array(buf)
                for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
                return buf
            }
            let buf = s2ab(wbout)
            var blob = new Blob([buf], {
                type: 'application/octet-stream'
            })
            return blob
        },
        uploadFile(file, fileList) {
            let files = { 0: file.raw }
            this.readExcel(files);
        },
        readExcel(files) {
            if (files.length <= 0) {
                return false
            } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
                this.$Message.error('上传格式不正确，请上传xls或者xlsx格式')
                return false
            }
            this.uploadExcelData(files);
        },
        uploadExcelData(file, fileList) {
            var _this = this;
            _this.fileName = file.name;
            let formDatas = new FormData();
            formDatas.append('file', file.raw);
            formDatas.append('deptId', _this.activeDept);
            importMember(this.activeDept, formDatas, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.uploadList = [];
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.getMembers();
                    var num = 10000 * Math.random();
                    this.updateTree = Number(num.toFixed(0));
                } else {
                    this.$message.error(res.msg);
                    this.uploadList = [];
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        handleAvatarSuccess() {
            this.$refs.upload.clearFiles();
        },
        uploadLogo(file) {
            var _this = this;
            this.fileName = file.file.name;
            let formDatas = new FormData();
            formDatas.append('file', file.file);
            editCompanyLogo(formDatas, {
                'Content-Type': 'multipart/form-data',
                Authorization: this.token,
                DeptId: this.dept
            }, {}).then(res => {
                if (res.code == 200) {
                    var url = res.url;
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                ///console.log(err);
            });
        },
        //查看学习记录
        viewStudyDerail(row) {
            this.$router.push(`/memberInfo/echarts-report/${row.userId}/${row.deptId}/${this.dept}`);
        },
        // 搜索
        searchMembers() {
            this.currentPage = 1
            this.getMembers()
        }
    }
}
</script>

<style scoped>
.page-container {

    width: 100%;
    height: 100%;
    display: flex;

    position: relative;
}

.page-slider {
    margin-top: 10px;
    height: 800px;
    width: 306px;
}

.page-content-right {
    width: 876px;
    height: 800px;
    overflow: hidden;
    animation: animi 1s;
    position: absolute;
    overflow-y: auto;
    left: 324px;
    padding-bottom: 18px;
    margin-top: 10px;
}

.page-content-container {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin-top: 18px;
}

.page-content-header {
    width: 100%;
    height: 80px;
    line-height: 80px;
    position: relative;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-branch {
    display: flex;
}

.page-header-operate {
    display: flex;
    width: 156px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid #F6986D;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F6986D;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 25px;
    cursor: pointer;
}

.page-header-operate-img {
    width: 16px;
    height: 15px;
    display: inline-block;
    position: relative;
    top: -2px;
}

.page-header-operate-label {
    margin-left: 8px;
}

.page-content-header-item {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
}

.page-content-header-item:hover {
    color: #4F79ED;
    cursor: pointer;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
}

.search-wrap {
    display: flex;
    justify-content: flex-end;
    margin: 15px 41px 30px 45px;
}

.page-content-wrapper {
    display: flex;
    margin-top: 30px;
    animation: animi 1s;
}

.table-wrapper {
    width: 791px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
}

.page-branch-content-wrapper {
    margin: 15px 41px 30px 45px;
}

.page-branch-item {
    padding: 16px 0px 16px 0px;
    border-bottom: solid #EAEAEA 1px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    display: flex;
    justify-content: space-between;
}

.page-branch-item:hover {
    cursor: pointer;
    color: #4F79ED;
}

.page-branch-item-icon {
    font-size: 16px;
}

.page-branch-no-data {
    padding: 16px 0px 16px 0px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.page-content {
    flex: 1;
    margin: 0px 41px 30px 45px;
}

.page-title-container {
    display: flex;
    width: 100%;
    height: 68px;
    background: #F8FAFF;
}

.page-title-wrapper {
    flex: 1;
    margin: 30px 41px 30px 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-title-item-active {
    width: 101px;
    height: 32px;
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-right: 15px;
}

.page-title-item {
    width: 101px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: center;
    line-height: 32px;
    margin-right: 15px;
}

.page-title-item:hover {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    color: #fff;
    cursor: pointer;
}

.page-title-left {
    display: flex;
}

.page-title-btn {
    width: 113px;
    height: 35px;
    border-radius: 18px;
    border: 1px solid #4F79ED;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-title-btn:hover {
    cursor: pointer;
}

.page-title-btn-gap {
    margin-right: 30px;
}

.page-title-btn-icon {
    width: 16px;
    height: 16px;
    margin-right: 9px;
}

.table-icon {
    width: 17px;
    height: 17px;
    cursor: pointer;
}

.table-icon-gap {
    margin-left: 27px;
}

.table-name {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.table-row {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}

.team-manage-container>>>.el-dialog__body {
    padding: 0px !important;
}

.team-manage-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-content>>>.el-form-item__label {
    text-align: left !important;
    font-size: 16px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #333333 !important;
}

.dialog-content>>>.el-input__inner {
    width: 274px !important;
    height: 30px !important;
    background: #FFFFFF !important;
    border-radius: 4px !important;
    border: 1px solid #D9D9D9 !important;
}

.editBranchForm-logo-wrapper {
    width: 274px;
    height: 30px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    display: flex;
    align-items: center;
}

.editBranchForm-logo-btn {
    width: 82px;
    height: 22px;
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 14px;
    margin-right: 11px;
}

.editBranchForm-logo-info {
    width: 160px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
}

.dialog-header {
    width: 100%;
    height: 59px;
    background: #F8FAFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 46px 77px 60px 77px;
}

.dialog-btn-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}

.dialog-content>>>.el-button {
    height: 36px !important;
    line-height: 36px !important;
    border-radius: 6px !important;
    display: flex !important;
    align-items: center !important;
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
}

.dialog-content>>>.el-button--primary {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%) !important;
}

.dialog-content>>>.el-button--default {
    border: 1px solid #4F79ED;
    color: #4F79ED !important;
}

.dialog-view-detail-btn {
    width: 144px;
    height: 30px;
    border-radius: 18px;
    border: 1px solid #4F79ED;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    line-height: 30px;
    text-align: center;
    position: relative;
    top: 2px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.dialog-view-detail-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff;
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    padding-bottom: 80px;
    margin-top: 30px;
}

.page-info-wrapper2 {
    width: 100%;
    height: 140px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    display: flex;
    position: relative;
}

.page-info-content {
    margin-left: 45px;
    flex: 1;
    height: 100%;
}

.page-info-content-company2 {
    display: flex;
    height: 100%;
    align-items: center;
}

.page-info-content-company-name {
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.company-logo {
    width: 28px;
    height: 28px;
}

.page-info-set {
    width: 76px;
    height: 26px;
    display: flex;
    margin-left: 21px;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 26px;
    margin-top: 5px;
    cursor: pointer;
    line-height: 26px;
    position: relative;
}

.page-info-shape-wrapper {
    width: 102px;
    height: 26px;
    position: absolute;
    top: 0px;
    left: 0px;
}

.page-info-reset-label {
    margin-left: 6px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F6986D;
}

.page-info-set-img-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
}

.rect-image {
    width: 100%;
    height: 100%;
}

.page-info-set-wrapper {
    position: relative;
    top: 2px;
}

.no-data-wrapper {
    width: 100%;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.no-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
}

.table-operate-no {
    display: flex;
    justify-content: center;
}

.table-operate-no-item {
    flex: 1;
    text-align: center;
}

.dialog-edit-detail-info {
    font-size: 14px;
    color: #909399;
}
</style>


